import React, { useEffect, useState } from "react"
import { useDispatch } from 'react-redux'
import { confirmResetPassword, AuthError } from "aws-amplify/auth"
import { LoginInput } from "../login-input"
import { LoginButton } from "../login-button"
import { utilService } from "../../../services/util-service"
import { StoreDispatch } from '../../../store/configure-store'
import { setUserMsg } from '../../../store/user'
import { UserMsg } from "../../../models/user"

interface ResetPasswordProps {
    setNextStep: React.Dispatch<any>
    userEmail: string
}

export const ResetPassword: React.FC<ResetPasswordProps> = ({ userEmail, setNextStep }) => {
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [confirmationCode, setConfirmationCode] = useState('')
    const dispatch = useDispatch<StoreDispatch>()

    useEffect(() => {
        return () => {
            setNewPassword("")
            setConfirmationCode("")
        }
    }, [])

    const newPasswordValidation = (password: string) => {
        return utilService.isValidPassword(password)
    }

    const confirmPasswordValidation = (confirmPAssword: string) => {
        return confirmPAssword === newPassword
    }

    const confirmCode = (code: string) => {
        const regex = /^\d{6}$/
        return regex.test(code)
    }

    const onFormSubmit = async (ev: React.FormEvent) => {
        ev.preventDefault()
        if (!newPasswordValidation(newPassword) ||
            !confirmPasswordValidation(confirmPassword) ||
            !confirmCode(confirmationCode)) {
            return
        }

        try {
            await confirmResetPassword({ username: userEmail, confirmationCode, newPassword })

            const msg: UserMsg = { type: 'success', txt: 'Password changed successfully' }
            dispatch(setUserMsg({ msg }))

            setNextStep({}) //returns to main login page
        } catch (error) {
            const err = error as AuthError
            if (err.name === 'CodeMismatchException') {
                const msg: UserMsg = { type: 'danger', txt: 'Wrong code. Please try again' }
                dispatch(setUserMsg({ msg }))
                return
            }

            if (err.name === 'ExpiredCodeException') {
                const msg: UserMsg = { type: 'danger', txt: "Code expired. Click 'Forgot password?' again" }
                dispatch(setUserMsg({ msg }))
                setNextStep({}) //returns to main login page
                return
            }

            if (err.name === 'LimitExceededException') {
                const msg: UserMsg = { type: 'danger', txt: 'Attempt limit exceeded. Please try again later' }
                dispatch(setUserMsg({ msg }))
                return
            }

            const msg: UserMsg = { type: 'danger', txt: 'Sending recovery code to your email failed' }
            dispatch(setUserMsg({ msg }))
            console.dir(err)
        }
    }

    return (<>
        <form onSubmit={onFormSubmit} className="update-password password-login-container">
            <LoginInput
                type="password"
                inputValue={newPassword}
                onSetInput={setNewPassword}
                validationFunc={newPasswordValidation}
                placeholder="New password"
                invalidMsg="Invalid password"
            />
            <LoginInput
                type="password"
                inputValue={confirmPassword}
                onSetInput={setConfirmPassword}
                validationFunc={confirmPasswordValidation}
                placeholder="Confirm new password"
                invalidMsg="password does not match"
            />
            <LoginInput
                type="text"
                inputValue={confirmationCode}
                onSetInput={setConfirmationCode}
                validationFunc={confirmCode}
                placeholder="Confirmation code (from email)"
                invalidMsg="Invalid code. Should be 6 digits"
            />
            <div className="login-btn-container">
                <LoginButton txt="update passsword" action={() => null} isFullColor={false} />
            </div>
        </form>
    </>
    )
}
